import { render, staticRenderFns } from "./Regencies.vue?vue&type=template&id=588327a6&"
import script from "./Regencies.vue?vue&type=script&lang=js&"
export * from "./Regencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports